function parseToken(rsa) {
  return {
    rsaTokenSuccess: rsa.retCode === 0,
  };
}

function serviceFactory({ api }) {
  const validateToken = (rsaToken,metaData) =>
    api
    .validateToken(rsaToken,metaData)
    .then(parseToken)
    .catch(parseToken);
  return {
    validateToken,
  };
}

module.exports = serviceFactory;
